/**
 * transport/errors.ts —— 错误面（交互态 §4「出错：错误码＋可操作提示，不吞错」）。
 * 纪律：错误一律结构化（code/phase/hint）；禁空 catch、禁吞错降级。
 * ★A-044①（20261006）：**提示文案不在本件写** —— `hint` 由 `errorText.hintFor(code, detail)`
 *   按**错误码分流**生成（文案唯一来源＝`transport/errorText.ts`，禁散写）；构造参数第 4 位
 *   只传**数据位** `detail`（如白名单允许目标），话术不许在调用点出现。
 */
import { E_CODES, hintFor } from "./errorText";

// 错误码闭集定义移入 `errorText.ts`（文案与码同源防漂移）；本导出面保持既有导入路径不变。
export { E_CODES };

export type TransportPhase =
  // ★20261011：`"heartbeat"` 已退役（心跳判死整链删除；phase 词域收窄）
  | "connect" | "decode" | "reconnect" | "write" | "egress";

export interface TransportErrorShape {
  code: string;
  message: string;
  phase: TransportPhase;
  hint: string;
}

/** 结构化传输错误（错误面唯一形态） */
export class TransportError extends Error {
  readonly code: string;
  readonly phase: TransportPhase;
  readonly hint: string;

  constructor(code: string, phase: TransportPhase, message: string, detail = "") {
    super(message);
    this.name = "TransportError";
    this.code = code;
    this.phase = phase;
    // 文案唯一来源＝errorText（按码分流；链路外错误码不得带链路话术）
    this.hint = hintFor(code, detail);
  }

  /** 错误面渲染形态（代码＋可操作提示） */
  toShape(): TransportErrorShape {
    return { code: this.code, message: this.message, phase: this.phase, hint: this.hint };
  }
}

/** 帧解析失败（不吞：上抛错误面，由界面显式呈现） */
export function frameInvalid(detail: string): TransportError {
  return new TransportError(
    E_CODES.FRAME_INVALID, "decode", "下行帧不符合契约形状：" + detail,
  );
}
